import { render } from "./rectificationDetail.vue?vue&type=template&id=54715eba&scoped=true&ts=true"
import script from "./rectificationDetail.vue?vue&type=script&lang=ts"
export * from "./rectificationDetail.vue?vue&type=script&lang=ts"

import "./rectificationDetail.vue?vue&type=style&index=0&id=54715eba&scoped=true&lang=less"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54715eba"]])

export default __exports__